export default {
  "TemplateVariables": "_TemplateVariables_dzfcd_1",
  "Variable": "_Variable_dzfcd_9"
};import "ni:sha-256;dyoErgFqxcclswC7WFgm7xYKGhN_eQAQDwq0u0zsDAc";